import React from 'react';

import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from './index.scss';
import { putHyphenIfEmpty } from '../../services/util';

import { truncate } from '../../util/lodashlike';
export const NS_INDIVIDUAL_ALERT_TYPE_0 = [
  [
    { label: 'Customer ID', value: 'partyKey' },
    { label: 'Age', value: 'customerAge' },
    { label: 'Gender', value: 'customerGender' },
    { label: 'Race', value: 'customerRace' },
    { label: 'Nationality', value: 'customerNationality' },
    { label: 'Country Of Birth', value: 'customerCountryOfBirth' },
    { label: 'Date Of Birth', value: 'dobCustomer' }
  ],
  [
    { label: 'Customer Name', value: 'rawPartyName' },
    { label: 'Alias', value: 'customerAlias' },
    { label: 'Type of Business', value: 'occupation' },
    { label: 'Segment', value: 'segmentName' },
    { label: 'Organization Unit', value: 'organisationUnit' },
    { label: 'Country of Residence', value: 'customerCountryOfResidence' },
    { label: 'Registered Address', value: 'customerLocation' }
  ]
];
export const NS_CORPORATE_ALERT_TYPE_0 = [
  [
    { label: 'Customer ID', value: 'partyKey' },
    { label: 'Country of Incorporation', value: 'countryOfIncorporation' },
    { label: 'Country of Operation', value: 'customerCountryOfOperation' },
    { label: 'Year of Incorporation', value: 'yearOfIncorporation' }
  ],
  [
    { label: 'Customer Name', value: 'rawPartyName' },
    { label: 'Alias', value: 'customerAlias' },
    { label: 'Segment', value: 'segmentName' },
    { label: 'Organization Unit', value: 'organisationUnit' },
    { label: 'Registered Address', value: 'customerLocation' }
  ]
];
export const TM_INDIVIDUAL = [
  [
    { label: 'Customer ID', value: 'partyKey' },
    { label: 'Type', value: 'formattedType' },
    { label: 'Age', value: 'customerAge' },
    { label: 'Gender', value: 'customerGender' },
    { label: 'Nationality', value: 'customerNationality' }
  ],
  [
    { label: 'Customer Name', value: 'name' },
    { label: 'Type of Business', value: 'occupation' },
    { label: 'Segment', value: 'segmentName' },
    { label: 'Postal Code', value: 'postalCode' },
    { label: 'Registered Address', value: 'customerLocation' }
  ]
];
export const TM_CORPORATE = [
  [
    { label: 'Customer ID', value: 'partyKey' },
    { label: 'Type', value: 'formattedType' }
  ],
  [
    { label: 'Customer Name', value: 'name' },
    { label: 'Segment', value: 'segmentName' },
    { label: 'Registered Address', value: 'customerLocation' }
  ]
];

class ShowMoreLessComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: true,
      expandableText: 'More'
    };
  }

  toggleShowMore = () => {
    this.setState({ showMore: !this.state.showMore }, () => {
      if (this.state.showMore) {
        this.setState({ expandableText: 'More' });
      } else {
        this.setState({ expandableText: 'Less' });
      }
    });
  };

  render() {
    const { value, customer, onClick } = this.props;
    const { showMore, expandableText } = this.state;
    const paraLength = 50;
    let itemValue = putHyphenIfEmpty(customer[value]);
    if (itemValue.length > paraLength) {
      if (onClick && showMore) {
        itemValue = truncate(itemValue, { length: paraLength, omission: '' });
      } else if (!onClick) {
        itemValue = truncate(itemValue, {
          length: paraLength,
          omission: '...'
        });
      }
    }
    return (
      <div className={style.alertLable}>
        <span title={customer[value]}>{itemValue}</span>
        {onClick && customer[value] && customer[value].length > paraLength && (
          <p onClick={this.toggleShowMore}>{expandableText}</p>
        )}
      </div>
    );
  }
}

const BarChartUtil = (props) => {
  const { barAttributesMap, customer, onClick } = props;
  return (
    <div className={classnames(style.ownerInfo)}>
      {onClick !== undefined && (
        <div className={style.closeButton} onClick={onClick}>
          <i className="fa fa-close" />
        </div>
      )}
      <div className={classnames(style.pdlr0, style.profileBody)}>
        {barAttributesMap.map((arrays) => {
          return (
            <ul className="list-unstyled">
              {arrays.map((item) => {
                return (
                  <li>
                    <div className={style.alertType}>
                      <span>{`${item.label}:`}</span>
                    </div>
                    <ShowMoreLessComponent
                      value={item.value}
                      onClick={onClick}
                      customer={customer}
                    />
                  </li>
                );
              })}
            </ul>
          );
        })}
      </div>
    </div>
  );
};

BarChartUtil.propTypes = {
  onClick: PropTypes.func,
  customer: PropTypes.object.isRequired,
  barAttributesMap: PropTypes.array.isRequired
};

export default BarChartUtil;

export const BarChartHOC = (customer, isNs, alertType, name, type, onClick) => {
  console.log(customer, isNs, alertType, name, type, onClick);
  let formattedType = '';
  switch (type) {
    case 'I':
      formattedType = 'Individual';
      break;
    case 'C':
      formattedType = 'Corporate';
      break;
    default:
      formattedType = type;
  }

  customer['formattedType'] = formattedType;
  customer['name'] = name;

  if (isNs) {
    if (alertType === 0) {
      return (
        <BarChartUtil
          customer={customer}
          onClick={onClick}
          barAttributesMap={NS_INDIVIDUAL_ALERT_TYPE_0}
        />
      );
    } else {
      return (
        <BarChartUtil
          customer={customer}
          onClick={onClick}
          barAttributesMap={NS_CORPORATE_ALERT_TYPE_0}
        />
      );
    }
  } else {
    if (type === 'I') {
      return (
        <BarChartUtil
          customer={customer}
          onClick={onClick}
          barAttributesMap={TM_INDIVIDUAL}
        />
      );
    } else {
      return (
        <BarChartUtil
          customer={customer}
          onClick={onClick}
          barAttributesMap={TM_CORPORATE}
        />
      );
    }
  }
};
